<div class="mainBrand">
    <h2 class="mainTit contain" data-aos="fade-right" data-aos-delay="200" data-aos-duration="800">더조각만의 특별한 기술과 원료로 완성한 <i></i>브랜드들을 소개합니다.</h2>
    <div class="mainBrandSlide" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide mainBrand01" data-image="./assets/lasted/img/brandSld01.png" data-title="Miracle" data-description="더조각 시스템 활용하는 전문가들을 위한 전문가 라인" data-link="https://thejogak.com/shopping-mall?cate=ALL">
                    <img src="./assets/lasted/img/mainBrand01.jpg" alt="">
                </div>
                <div class="swiper-slide mainBrand02" data-image="./assets/lasted/img/brandSld02.png" data-title="Scalp-Fit" data-description="더조각만의 노하우로 완성한 차별화된 헤어케어 라인" data-link="https://thejogak.com/shopping-mall?cate=ALL">
                    <img src="./assets/lasted/img/mainBrand02.jpg" alt="">
                </div>
                <div class="swiper-slide mainBrand03" data-image="./assets/lasted/img/brandSld03.png" data-title="Derma H" data-description="더조각 연구진의 연구로 완성한 수소 스킨케어 라인" data-link="https://thejogak.com/shopping-mall?cate=ALL">
                    <img src="./assets/lasted/img/mainBrand03.jpg" alt="">
                </div>
                <div class="swiper-slide mainBrand04" data-image="./assets/lasted/img/brandSld04.png" data-title="Incarebio" data-description="더조각 이너뷰티 프로그램; 디톡스& 헬스 이너케어 라인" data-link="https://thejogak.com/shopping-mall?cate=ALL">
                    <img src="./assets/lasted/img/mainBrand04.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="swiper-pagination contain"></div>
    </div>
</div>